module.exports = __webpack_public_path__ + "img/5.ff991605.jpg";